import Request from 'src/utils/request'

/**
 * 保存数据大屏
 * @returns
 */
export function saveScreenApi (data) {
  return Request({
    url: '/panel',
    method: 'post',
    data,
  })
}

/**
 * 获取模版
 * @returns
 */
export function getTemplateListApi () {
  return Request({
    url: '/panel/screen-template',
    method: 'get',
  })
}

/**
 * 删除模版
 * @returns
 */
export function deleteTemplateApi (id) {
  return Request({
    url: `/panel/screen-template/${id}`,
    method: 'delete',
  })
}
